"use client"

import { formatPhoneNumber } from "react-phone-number-input"
import {type CountryCode, getCountryCallingCode} from "libphonenumber-js"

export function parsePhoneNumber(number: string){
    if (!number) return ''
    return formatPhoneNumber(number).replace(/\s/g, '')
}

export function parseCountryCode(country: string) {
    return getCountryCallingCode(country as CountryCode)
}